import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { fiterList } from './config';
import icTransaction from 'assets/svg/ic_transaction.svg';
import icTotalListed from 'assets/svg/ic_total_listed.svg';
import icTotaTraded from 'assets/svg/ic_total_traded.svg';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchMetricStatDashboard } from 'src/redux/actions';
import { GroupCount } from 'src/models';
import CountUp from './../CountUp';
import StatisticsPlaceHolder from './StatisticsPlaceHolder';
import { AppError } from 'src/redux/types';
import PageContent from 'src/Components/PageContent';
import ErrorView from 'src/Components/ErrorViewV2';
import { ErrorViewType } from 'src/Components/ErrorViewV2/config';
import useActiveTab from '@wolffun/shared/src/hooks/useActiveTab';

const Statistics = ({
  className
}) => {
  const [filterKey, setFilterKey] = React.useState(GroupCount.Time_24_hours);
  const dispatch = useTypedDispatch();
  const {
    data,
    invalidated,
    loading,
    error
  } = useTypedSelector(state => state.homeMetricStats);
  const invalidatedStatistics = invalidated && !data;
  const onFetch = React.useCallback(filterKey => {
    dispatch(fetchMetricStatDashboard(filterKey));
  }, [dispatch]);
  React.useEffect(() => {
    onFetch(filterKey);
  }, [filterKey, onFetch]);
  React.useEffect(() => {
    let timeout;

    if (data !== null && data !== void 0 && data.timeout) {
      timeout = setTimeout(() => {
        onFetch(filterKey);
      }, data.timeout * 1000);
    }

    return () => {
      clearInterval(timeout);
    };
  }, [data, dispatch, filterKey, onFetch]);
  const {
    lineRef,
    refs
  } = useActiveTab({
    selectedKey: filterKey,
    data: fiterList,
    onFilter: item => item.id === filterKey
  });

  const renderContent = () => {
    if (!data) {
      return null;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.container, className)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.header
    }, fiterList.map((e, index) => /*#__PURE__*/React.createElement("div", {
      key: e.id,
      onClick: () => {
        setFilterKey(e.id);
      },
      className: classNames(styles.wrapTxt, filterKey === e.id && styles.active),
      ref: ref => {
        if (ref) {
          refs.current[index] = ref;
        }
      }
    }, /*#__PURE__*/React.createElement("span", null, e.label))), /*#__PURE__*/React.createElement("div", {
      className: styles.line,
      ref: lineRef
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.content
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: icTotalListed
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapLabel
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "Total Listed")), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, /*#__PURE__*/React.createElement(CountUp, {
      end: data.listedCount
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: icTransaction
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapLabel
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "Transaction Volume (THC)")), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, /*#__PURE__*/React.createElement(CountUp, {
      end: data.transactionRealValue
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles.item
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.icon,
      src: icTotaTraded
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.right
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapLabel
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.label
    }, "Items Traded")), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, /*#__PURE__*/React.createElement(CountUp, {
      end: data.tradedCount
    }))))));
  };

  const renderLoading = () => /*#__PURE__*/React.createElement(StatisticsPlaceHolder, {
    className: styles.containerSkeleton
  });

  const renderError = () => /*#__PURE__*/React.createElement(ErrorView, {
    config: {
      title: 'Sorry, something went wrong.',
      content: 'Please try again.',
      type: ErrorViewType.Custom
    },
    className: styles.empty
  });

  return /*#__PURE__*/React.createElement(PageContent, {
    invalidated: invalidatedStatistics,
    loading: loading,
    error: error !== AppError.NO_ERROR,
    renderContent: renderContent,
    renderLoading: renderLoading,
    renderError: renderError
  });
};

export default Statistics;